import React from 'react';
import DeliveryLocationForm from './DeliveryLocationForm';
import DeliveryLocationListItem from './DeliveryLocationListItem';
import LoadingContainer from './LoadingContainer';
import ConfirmationDialog from './ConfirmationDialog';
import { unexpectedErrorFunction, postWithToken } from '../utils';
import { AuthContext } from './Layout';
import { BASE_PATH } from '../config';

export default (props) => {
    const { 
        handleLocationAdded, 
        deliveryLocations, 
        selectedDeliveryLocation, 
        setSelectedDeliveryLocation, 
        selectedVerbiage="DEFAULT",
        handleLocationsUpdated
    } = props;
    const user = React.useContext(AuthContext);
    const [formActive, setFormActive] = React.useState(false);
    const [confirmationProps, setConfirmationProps] = React.useState({dialogOpen: false});
    const [editIndex, setEditIndex] = React.useState(null);
    const [updating, setUpdating] = React.useState(false);

    function handleSubmitSuccess(input) {
        handleLocationAdded(input);
        setFormActive(false);
    }
    function handleLocationUpdated(newValue, originalValue) {
        setUpdating(true);
        postWithToken(user.getIdToken(), `${BASE_PATH}/updateDeliveryLocations`, {
            deliveryLocations: deliveryLocations.map((location) => {
                if (location === originalValue) {
                    return newValue;
                }
                return location;
            }),
            defaultDeliveryLocation: selectedDeliveryLocation === originalValue ? newValue : undefined
        })
        .then(({ data }) => {
            handleLocationsUpdated(data, 'update');
        })
        .catch(unexpectedErrorFunction)
        .finally(() => {
            setEditIndex(null);
            setUpdating(false);
        })
    }
    function handleLocationRemove(value) {
        setConfirmationProps({
            dialogOpen: true,
            handleConfirm: () => {
                setUpdating(true);
                setConfirmationProps({ ...confirmationProps, dialogOpen: false });
                postWithToken(user.getIdToken(), `${BASE_PATH}/updateDeliveryLocations`, {
                    deliveryLocations: deliveryLocations.filter(location => location !== value)
                })
                .then(({ data }) => {
                    handleLocationsUpdated(data);
                })
                .catch(unexpectedErrorFunction)
                .finally(() => {
                    setUpdating(false);
                    setConfirmationProps({ dialogOpen: false })
                })
            },
            handleCancel: () => setConfirmationProps({ dialogOpen: false }),
            header: "Delete Delivery Location",
            message: "Are you sure you want to permanently delete this delivery location?",
            btnText: "YES, DELETE",
            btnClass: "error-btn"
        })
    }
    function renderContent() {
        if (formActive) {
            return (
                <DeliveryLocationForm 
                    handleSubmitSuccess={handleSubmitSuccess} 
                    handleCancelClick={() => setFormActive(false)} 
                />
            )
        }
        else if (editIndex === null) {
            return <button className='btn primary-outline-btn small-btn' onClick={() => setFormActive(true)}>ADD DELIVERY LOCATION</button>
        }
        return null;
    }
    return (
        <div>
            {deliveryLocations && deliveryLocations.length > 0 ?
            deliveryLocations.map((location, index) => {
                const active = location === selectedDeliveryLocation;
                return (
                    <DeliveryLocationListItem 
                        key={location}
                        location={location}
                        active={active}
                        selectedVerbiage={selectedVerbiage}
                        setSelectedDeliveryLocation={setSelectedDeliveryLocation}
                        handleLocationRemove={handleLocationRemove}
                        setEditIndex={setEditIndex}
                        index={index}
                        editing={index === editIndex}
                        handleLocationUpdated={handleLocationUpdated}
                    />
                )
            })
            :
            <p>No delivery locations to display</p>
            }
            <div className='add-margin-2'>
                {renderContent()}
            </div>
            {updating && <div className='updating-container'><LoadingContainer text="Please wait while we update your preferences..." /></div>}
            <ConfirmationDialog {...confirmationProps} />
        </div>
    )
}